import api from '@pray/shared/utils/api';

export type PrayRadioContentAiring = {
  daily_item_id: string;
  daily_series_id: string | null;
  scheduled_at: string | null;
};

/**
 * The Pray Radio airing(s) of a Content episode (PB-37977): its live
 * daily-item copies with their scheduled air times. `scheduled_at` is null
 * for a copy that exists but isn't on the calendar.
 */
export async function getPrayRadioContentAirings({ artistId, contentId }: {
  artistId: string;
  contentId: string;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/pray-radio-airing`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
